module.exports = __webpack_public_path__ + "static/media/libreta (2).f5127e0a.JPG";